import { normalize } from 'normalizr';

import { callApi } from 'utils/api';
import * as schemas from 'schemas';

export function categoriesFetch(type) {
  return callApi('/categories', {
    query: {
      type
    }
  })
  .then(json => {
    const { result, entities } = normalize(json, schemas.categoriesArraySchema);
    return {categoriesIds: result, entities};
  });
}



/** WEBPACK FOOTER **
 ** ./src/members/state/categories/api.js
 **/